class ResponsiveVideo {
  constructor(element) {
    if (!(element instanceof HTMLVideoElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.source = this.getSource();
    this.mobileUrl = this.element.dataset.mobileSrc ?? null;
    this.desktopUrl = this.source.src ?? null;
    this.currentState = "desktop";

    this.initEvents();
  }

  initEvents() {
    this.checkSrc();
    this.element.load();
    this.element.play();

    window.addEventListener("resize", this.checkSrc.bind(this), {passive: true});
  }

  checkSrc() {
    let reload = false;

    if(!this.source)
      return false;

    if (window.outerWidth < 481 && this.currentState === "desktop") {
      this.source.src = this.mobileUrl;
      this.currentState = "mobile";
      reload = true;
    } else if (window.outerWidth >= 481 && this.currentState === "mobile") {
      this.source.src = this.desktopUrl;
      this.currentState = "desktop";
      reload = true;
    }

    if(reload){
      this.element.load();
      this.element.play();
    }

    return true;
  }

  getSource() {
    const sources = this.element.getElementsByTagName('source');
    return sources[0] ?? null;
  }
}

export default ResponsiveVideo;
